module.exports = __webpack_public_path__ + "img/model_65.b8ecc8a0.jpg";